(function (context) {
    // DEBOUNCE method taken from Underscore.js
    // @todo: use lodash or underscore from package
    /*eslint-disable*/
    context._ = context._ || {};

    // Returns a function, that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If `immediate` is passed, trigger the function on the
    // leading edge, instead of the trailing.
    _.debounce =
        _.debounce ||
        function (func, wait = 250, immediate) {
            var timeout;
            return function () {
                var context = this,
                    args = arguments;
                var later = function () {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        };
    /*eslint-enable*/
})(window);
